import * as React from 'react';
import { useRouteMatch } from 'react-router';
import { Redirect, Switch } from 'react-router-dom';

import { PrivateRoute } from '~/components/Auth';
import { NewEmployee } from '~/scenes/PortalModules/NewEmployee';
import { NewEmployeeCandidate } from '~/scenes/PortalModules/NewEmployeeCandidate';
import { useNewEmployeeViewAccess } from '~/scenes/PortalViews/Views/EmployeeViews/NewEmployeeView/useNewEmployeeViewAccess';

export const NewEmployeeRouter = () => {
  const { path } = useRouteMatch();

  const { canAddEmployee, canAddEmployeeCandidate } =
    useNewEmployeeViewAccess();

  return (
    <Switch>
      <PrivateRoute
        path={`${path}/candidate`}
        render={() => {
          if (canAddEmployeeCandidate) {
            return <NewEmployeeCandidate />;
          }

          return <Redirect to={path} />;
        }}
      />
      <PrivateRoute
        exact
        path={path}
        render={() => {
          if (canAddEmployee) {
            return <NewEmployee />;
          } else if (canAddEmployeeCandidate) {
            return <Redirect to={`${path}/candidate`} />;
          }

          return <Redirect to={'/portal/home'} />;
        }}
      />
    </Switch>
  );
};
